function tokenize(query) {
  if (query == undefined) return {};

  var tokens = query.split("/");
  var params = {};
  if (tokens.length > 1) {
    for (var i = 0, len = tokens.length; i < len; i += 2) {
      params[tokens[i]] = tokens[i + 1];
    }
  }
  return params;
}

function stringify(params) {
  const pairs = Object.keys(params).map(key => {
    return key + "/" + params[key];
  });

  return pairs.join("/");
}

const SearchQuery = {
  setParameter: function(query, key, value) {
    var params = tokenize(query);

    if (key == "city") {
      params[key] = slugs["city"][value];
    } else if (key == "region") {
      params[key] = slugs["region"][value];
    } else if (key == "country") {
      params[key] = slugs["country"][value];
    } else {
      params[key] = value;
    }
    return stringify(params);
  },

  setDates: function(query, dates) {
    dates = dates.replace(/\//g, "-");
    var tokens = dates.split(" -- ");
    var stayStart = tokens[0];
    var stayEnd = tokens[1];
    query = SearchQuery.setParameter(query, "stayStart", stayStart);
    query = SearchQuery.setParameter(query, "stayEnd", stayEnd);
    return query;
  },

  setPriceRange: function(query, priceRange) {
    query = SearchQuery.setParameter(query, "priceRange", priceRange);
    return query;
  }
};
//export {tokenize, stringify};
//export default SearchQuery;
module.exports = {
  tokenize: tokenize,
  stringify: stringify,
  setDates: SearchQuery.setDates,
  setParameter: SearchQuery.setParameter,
  setPriceRange: SearchQuery.setPriceRange
};
